export default __webpack_public_path__ + "static/media/report-bottom-image.60c2e52f.png";